import React, { Component } from "react";
import { Button, Spinner, Collapse } from "react-bootstrap";

import NumberFormat from "react-number-format";
import axiosInstance from "../../_helpers/axiosConfig";

import "./../style.css";

export default class VerifyPhone extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: [],
      sendingCode: false,
      verifyingPhone: null,
      shouldResendCode: false,
      hasAlreadySentCode: false,
    };
  }

  resendVerifyCode = () => {
    if (this.state.verifyingPhone === true) {
      return;
    }
    if (this.state.shouldResendCode === false) {
      return (
        <a
          href="/"
          onClick={(e) => {
            e.preventDefault();
            this.setState({ shouldResendCode: true, resent: false });
          }}
        >
          {this.state.hasAlreadySentCode ? (
            <small>Still didn't recieve a code?</small>
          ) : (
            <span>Didn't recieve a code?</span>
          )}
        </a>
      );
    } else {
      return (
        <Button
          size="sm"
          variant="secondary"
          disabled={this.state.sendingCode}
          onClick={() => {
            this.setState(
              { sendingCode: true, hasAlreadySentCode: true },
              function () {
                this.handleResendCode();
              }
            );
          }}
        >
          {this.state.sendingCode ? (
            <span>
              <Spinner animation="border" size="sm" /> Sending...
            </span>
          ) : (
            "Send another code"
          )}
        </Button>
      );
    }
  };

  handleResendCode = () => {
    axiosInstance
      .request({
        method: "POST",
        url: `/vaccine/verification-code`,
        data: {
          phoneNumber: this.props.phoneNumber,
        },
      })
      .then((response) => {
        this.setState({
          shouldResendCode: false,
          sendingCode: false,
          resent: true,
        });
      });
  };

  render() {
    return (
      <Collapse in={this.props.show}>
        <div className="row">
          <div className="col">
            <div className="form-group pb-4">
              <label>
                <span className="text-danger">*</span> Verification Code{" "}
              </label>
              <div className="row">
                <div className="col">
                  Please enter the code sent to {this.props.phoneFormatted}
                </div>
              </div>

              <div className="row pt-3">
                <div className="col p-0">
                  <div className="form-group">
                    <NumberFormat
                      onValueChange={(e) => this.props.setVerify(e.value)}
                      name="verify"
                      value={this.props.verifyCode}
                      className="form-control"
                      placeholder="Verification Code"
                    />
                  </div>
                  {this.props.showError}
                </div>
                <div className="col-sm-auto col-12 px-0 px-sm-3 text-right pr-sm-0">
                  {this.resendVerifyCode()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Collapse>
    );
  }
}
